import api from "./axiosInterceptor";

export const connectQuickBooks = ({ code, state, realmId }) =>
  api.get(
    `/apps/quickbooks/callback?code=${code}&state=${state}&realmId=${realmId}`
  );

export const fetchCategories = (category) =>
  api.get("/apps/quickbooks/objects/" + category);
